<template>
  <v-card>
    <ValidationObserver ref="observer">
      <v-card-title>
        <span class="headline">{{ dialogTitle }}</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <ValidationProvider name="nom" rules="required|min:2" v-slot="{ errors }">
                <v-text-field
                  label="Nom"
                  v-model="item.name"
                  :error-messages="errors[0]"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Adresse"
                v-model="item.address.address"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Code postal"
                v-model="item.address.zipCode"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Ville"
                v-model="item.address.city"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Pays"
                v-model="item.address.country"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="N° téléphone"
                v-model="item.phone_number"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Email"
                v-model="item.email"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Nom du contact"
                v-model="item.contact_name"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-select
                label="Type de contrat"
                v-model="item.contract"
                :items="contracts"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-select
                label="Type de fournisseur"
                v-model="item.type"
                :items="types"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Raison sociale"
                v-model="item.company_name"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Forme juridique"
                v-model="item.legal_form"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="SIRET"
                v-model="item.siret"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="N° TVA"
                v-model="item.vat_number"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Code APE"
                v-model="item.ape_code"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="IBAN"
                v-model="item.iban"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="BIC"
                v-model="item.bic"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Devise"
                v-model="item.devise"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Site web"
                v-model="item.website_url"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Langue"
                v-model="item.lang"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <ValidationProvider name="nom" :rules="{ required: isNewItem, uniqueUsername: { id: item.producer_id } }" v-slot="{ errors }">
                <v-text-field
                  label="Nom d'utilisateur"
                  v-model="item.username"
                  :error-messages="errors[0]"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <ValidationProvider name="mot de passe" :rules="{ required: isNewItem, strongPassword: true }" v-slot="{ errors }">
              <v-text-field
                label="Mot de passe"
                v-model="item.password"
                :error-messages="errors[0]"
              ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-text>
        {{ error }}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dismiss">Annuler</v-btn>
        <v-btn color="blue darken-1" text @click="save">Sauver</v-btn>
      </v-card-actions>
    </ValidationObserver>
  </v-card>
</template>

<script>
import _ from 'lodash';
import randomize from 'randomatic';
import { mapState } from 'vuex';

import { PRODUCER_CREATE, PRODUCER_UPDATE } from '@/store/actions/producer';


export default {
  name: 'ProviderEdit',

  data () {
    return {
      item: {},
      error: '',

      contracts: [
        { text: 'Standard', value: 'standard' },
        { text: 'Exclusivité', value: 'exclusive' },
        { text: 'Premium', value: 'premium' }
      ],

      types: [
        { text: 'Indépendant', value: 'independent' },
        { text: 'Négociant', value: 'dealer' },
        { text: 'Courtier', value: 'broker' },
        { text: 'Distributeur', value: 'distributor' },
        { text: 'Coopérative', value: 'cooperative' },
        { text: 'Embouteilleur', value: 'bottler' },
        { text: 'Fournisseur de packs', value: 'pack_provider' }
      ]
    };
  },

  computed: {
    ...mapState({
      defaultItem: state => state.producer.defaultItem
    }),
    isNewItem () {
      return !this.item.producer_id;
    },
    dialogTitle () {
      return this.isNewItem ? 'Nouvel élément' : 'Edition';
    }
  },

  created () {
    this.reset();
  },

  mounted () {
  },

  methods: {
    edit (_item) {
      this.item = _.merge({}, this.item, this.defaultItem, _item);
      if (!_item) {
        this.item.password = randomize('Aa0', 8);
      }
    },

    reset () {
      this.item = _.merge({}, this.item, this.defaultItem);
      this.error = '';

      requestAnimationFrame(() => {
        this.$refs.observer.reset();
      });
    },

    dismiss () {
      this.$emit('dismissed');
      this.reset();
    },

    async save () {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return;
      }

      // Send to Store
      try {
        if (this.isNewItem) {
          await this.$store.dispatch(PRODUCER_CREATE, this.item);
        } else {
          await this.$store.dispatch(PRODUCER_UPDATE, this.item);
        }
      } catch (err) {
        this.error = err;
        return;
      };

      // Close
      this.$emit('saved');

      // Reset the values
      this.reset();
    }
  }
};
</script>
